var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_small"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2027 16.7635L7.71744 8.27822C7.42752 7.9883 7.42752 7.50747 7.71744 7.21756C8.00735 6.92764 8.48818 6.92764 8.7781 7.21756L17.2634 15.7028C17.5533 15.9928 17.5533 16.4736 17.2634 16.7635C16.9735 17.0534 16.4926 17.0534 16.2027 16.7635Z",
    fill: "#102142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71744 16.7635C7.42752 16.4736 7.42752 15.9928 7.71744 15.7028L16.2027 7.21756C16.4926 6.92764 16.9735 6.92764 17.2634 7.21756C17.5533 7.50747 17.5533 7.9883 17.2634 8.27822L8.7781 16.7635C8.48818 17.0534 8.00735 17.0534 7.71744 16.7635Z",
    fill: "#102142"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmall);
export default __webpack_public_path__ + "static/media/close_small.7a84a7e98bea12a6fd23c09499498612.svg";
export { ForwardRef as ReactComponent };